module.exports = __webpack_public_path__ + "static/RSL-473b7127cefd7bca11b08878d2231bbc.mp3";